import React, { useRef, useEffect } from "react";
import "./DhenkanalNavbarPage.css";

// import posterimg from "../assest/poster.png";
import posterimg from "../assest/Utkal.jpg";

// import usericon from "../assest/user.png";
import collectorName from "../assest/CollectorBoudh.jpg"
import usericon from "../assest/cdoboudh.jpeg";


// import image1 from "../assest/image1.png";
import image1 from "../assest/boudh Waterfall.jpeg"
// import image2 from "../assest/image2.png";
import image2 from "../assest/boudhmandir.jpg";

// import image3 from "../assest/image3.png";
import image3 from "../assest/Asurgarhboudh.jpeg"
import image4 from "../assest/SargipaliWaterfall.jpg"



import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dhealnavbar from "../Navbar/dhealnavbar";

export default function DhenkanalNavbarPage(
    { toggleTheme,
        increaseFont,
        decreaseFont,
        resetFont }) {

    // ************* ADDED ONLY THIS ****************
    // const [fontSize, setFontSize] = useState(100);

    // const increaseFont = () => setFontSize(prev => Math.min(prev + 10, 150));
    // const decreaseFont = () => setFontSize(prev => Math.max(prev - 10, 70));
    // const resetFont = () => setFontSize(100);
    // const [theme, setTheme] = useState("light");

    // const toggleTheme = () => {
    //     setTheme(theme === "light" ? "dark" : "light");
    // };



    const navigate = useNavigate();
    const { t } = useTranslation();

    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const amount = 300;
            scrollRef.current.scrollBy({
                left: direction === "left" ? -amount : amount,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        const autoScroll = setInterval(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
            }
        }, 3000);

        return () => clearInterval(autoScroll);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (

        <div
            // className={`theme-${theme} DhenkanalNavbarPage-container`}
            // style={{ fontSize: "inherit" }}
            className="DhenkanalNavbarPage-container"

        >

            <Dhealnavbar
                increaseFont={increaseFont}
                decreaseFont={decreaseFont}
                resetFont={resetFont}
                toggleTheme={toggleTheme}
            />

            {/* KONARK FESTIVAL SECTION */}
            <div className="DhenkanalSecondPages-container">

                {/* LEFT — FESTIVAL POSTER */}
                <div className="DhenkanalSecondPages-left">
                    <img
                        src={posterimg}
                        alt="Konark Festival Banner"
                        className="DhenkanalSecondPages-banner"
                    />
                </div>

                {/* RIGHT — OFFICERS SECTION */}
            <div className="DhenkanalSecondPages-right"> 

             
                   <div className="DhenkanalSecondPages-officer">
                        <img
                            src={collectorName}
                            alt={t("collectorName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                       <div className="DhenkanalSecondPages-officer-text">
  <p className="DhenkanalSecondPages-officer-name">
    {t("collectorName")}
  </p>
  <p className="DhenkanalSecondPages-officer-title">
    {t("collectorTitle")}
  </p>
</div>
                    </div> 

                   
                     <div className="DhenkanalSecondPages-officer">
                        <img
                            src={usericon}
                            alt={t("spName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                       <div className="DhenkanalSecondPages-officer-text">
  <p className="DhenkanalSecondPages-officer-name">
    {t("spName")}
  </p>
  <p className="DhenkanalSecondPages-officer-title">
    {t("spTitle")}
  </p>
</div>
                    </div> 
                     </div> 
            </div>

            {/* TAB BUTTON SECTION */}
            <div className="tabcolpagesss-container">
                {/* <div
                    className="tabcolpagesss-item"
                    onClick={() => navigate("/dhenkanalfirstpage")}
                >
                    {t("dhenkanal360")}
                </div> */}

                {/*<div className="tabcolpagesss-item" onClick={() => window.open("https://skillconnect.dhenkanalservice.in/", "_blank")}>
                        {t("skillConnect")}
                    </div>*/}
                {/* <div className="tabcolpagesss-item" >
                   
                </div> */}
                <div className="tabcolpagesss-item" onClick={() => window.open("https://dashboard.boudhdistrict.in/", "_blank")}>
                    {t("samadhan")}
                </div>
            </div>

            {/* ABOUT DHENKANAL SECTION */}
            <div className="Dhenkanalaboutpages-heading">{t("about")}</div>
            <div className="Dhenkanalaboutpages-container">


                <div className="Dhenkanalaboutpages-content">
                    <p className="about-text">{t("aboutText")}</p>

                    <button
                        className="Dhenkanalaboutpages-btn"
                        onClick={() => navigate("/aboutpage")}
                    >
                        {t("readMore")}
                    </button>
                </div>
            </div>

         {/* TOURISM SECTION */}
<div className="tourism-section">

    <h2 className="tourism-heading">
        {t("tourism_or")}
    </h2>

    <div className="Tourismpagesss-slider-wrapper">

        <div className="Tourismpagesss-cards">

            {/* CARD 1 */}
            <div className="Tourismpagesss-card">
                <img src={image1} className="Tourismpagesss-card-image" alt="" />
                <h3 className="Tourismpagesss-card-title">{t("tourism.kapilash_title")}</h3>
                <p className="Tourismpagesss-card-desc">{t("tourism.kapilash_desc")}</p>
            </div>

            {/* CARD 2 */}
            <div className="Tourismpagesss-card">
                <img src={image2} className="Tourismpagesss-card-image" alt="" />
                <h3 className="Tourismpagesss-card-title">{t("tourism.science_centre_title")}</h3>
                <p className="Tourismpagesss-card-desc">{t("tourism.science_centre_desc")}</p>
            </div>

            {/* CARD 3 */}
            <div className="Tourismpagesss-card">
                <img src={image3} className="Tourismpagesss-card-image" alt="" />
                <h3 className="Tourismpagesss-card-title">{t("tourism.dandadhar_title")}</h3>
                <p className="Tourismpagesss-card-desc">{t("tourism.dandadhar_desc")}</p>
            </div>

            {/* CARD 4 */}
            <div className="Tourismpagesss-card">
                <img src={image4} className="Tourismpagesss-card-image" alt="" />
                <h3 className="Tourismpagesss-card-title">{t("tourism.kualo_title")}</h3>
                <p className="Tourismpagesss-card-desc">{t("tourism.kualo_desc")}</p>
            </div>

        </div>
    </div>
</div>

            {/* FOOTER */}
            <div className="footercolpagesss-container">
                <p className="footercolpagesss-text">{t("footerText")}</p>
            </div>
        </div>

    );
}
